import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data || response;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getTorqRgstManagements: async ({ searchParams, currentPage, pageUnit }) => {
		const queryStr = objectToQuerystring({
			startDt: searchParams.startDt,
			endDt: searchParams.endDt,
			mesEqipNm: searchParams.mesEqipNm?.trim(),
			mesEqipNo: searchParams.mesEqipNo?.trim(),
			currentPage,
			pageUnit
		});
		try {
			const response = await client.get(`${BASE_URL}/mmc/mmcm/torqRgst/v1/torqRgsts${queryStr}`);
			return response?.data || response;
		} catch (error) {
			throw error?.response?.data;
		}
	},
	postTorqRgstManagement: async param => {
		try {
			const response = await client.post(`${BASE_URL}/mmc/mmcm/torqRgst/v1/status/${param.status}`, param.data);
			return response?.data || response;
		} catch (error) {
			throw error?.response?.data;
		}
	},
	async excelTempDown(params) {
		// 엑셀템플릿 다운로드
		try {
			return await client.post(`${BASE_URL}/comm/common/qmsFileInfo/v1/downExcelTemp`, params, {
				responseType: 'blob'
			});
		} catch (error) {
			throw error.response?.data;
		}
	}
};
